import { render } from "./BadgeAndRankSystem.vue?vue&type=template&id=7a57874b&scoped=true"
import script from "./BadgeAndRankSystem.vue?vue&type=script&lang=js"
export * from "./BadgeAndRankSystem.vue?vue&type=script&lang=js"

import "./BadgeAndRankSystem.vue?vue&type=style&index=0&id=7a57874b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a57874b"]])

export default __exports__